module.exports = require("path");


/*****************
 ** WEBPACK FOOTER
 ** external "path"
 ** module id = 12
 ** module chunks = 0
 **/